import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CustomizeFieldsFactory {
  conceptEvaluations:any = [];
  contentTypeList: any = [];
  reportList: any = [];
  listValueColors: any = [];
  // constructor() { }

  setConceptsEvaluation(items: any){
    this.conceptEvaluations = items;
  }

  getConceptsEvaluation(){
    return this.conceptEvaluations;
  }

  setContentTypeList(items: any){
    this.contentTypeList = items;
  }

  getContentTypeList(){
    return cloneDeep(this.contentTypeList);
  }

  setReportList(items: any){
    this.reportList = items;
  }

  getReportList(){
    return this.reportList;
  }

  setListValueColors(items: any){
    items.forEach((color: any) => {
      color.indexOrder = this.getColorPosition(color);
    });
    this.listValueColors = items.sort(this.orderList('indexOrder'));
  }

  getColorPosition(color: any){
    switch(color.listValueColorId){
      case 1:
      // case '#5EC6DD':
        return 5;
      case 2:
      // case '#7683B5':
        return 10;
      case 3:
      // case '#77D166':
        return 4;
      case 4:
      // case '#7A58AC':
        return 9;
      case 5:
      // case '#929B9C':
        return 6;
      case 6:
      // case '#9A7E74':
        return 7;
      case 7:
      // case '#C43741':
        return 1;
      case 8:
      // case '#E5869D':
        return 8;
      case 9:
      // case '#F1923E':
        return 2;
      case 10:
      // case '#F1BC3E':
        return 3;
      default:
        return 11;
    }
  }

  orderList(type: any){
    return function(a: any, b:any) {
      if (a[type] > b[type]) {
        return 1;
      }
      return a[type] < b[type] ? -1 : 0;
    }
  }

  getListValueColors(){
    return this.listValueColors;
  }
}
